import { motion } from 'framer-motion';
import { skillsData } from '../../config';

const SkillsTab = () => {
  const skills = {
    "Languages": skillsData.languages,
    "Frontend Development": skillsData.frontend,
    "Backend & APIs": skillsData.backend,
    "Databases": skillsData.database,
    "Mobile Development": skillsData.mobile,
    "Cloud & DevOps": skillsData.devops,
    "Tools & Others": skillsData.tools,
    "Emerging Tech": skillsData.emerging,
  };

  return (
    <div className="lg:pt-12 pt-8 w-full md:w-12/12 px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-5xl mx-auto"
      >
        <div className="mb-12">
          <h2 className="text-4xl font-bold mb-3 text-gray-900 dark:text-white">Skills & Technologies</h2>
          <p className="text-gray-600 dark:text-gray-400">
            Technologies and tools I work with regularly
          </p>
        </div>
        
        <div className="space-y-8">
          {Object.entries(skills).map(([category, items], catIndex) => (
            <motion.div
              key={category}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: catIndex * 0.1 }}
              className="pb-6 border-b border-gray-200 dark:border-gray-800 last:border-b-0"
            >
              <h3 className="text-sm font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400 mb-4">
                {category}
              </h3>
              <div className="flex flex-wrap gap-2.5">
                {items.map((skill, skillIndex) => {
                  const IconComponent = skill.icon;
                  return (
                    <motion.div
                      key={skillIndex}
                      initial={{ opacity: 0, scale: 0.9 }}
                      animate={{ opacity: 1, scale: 1 }}
                      transition={{ duration: 0.3, delay: (catIndex * 0.1) + (skillIndex * 0.03) }}
                      whileHover={{ scale: 1.05 }}
                      className="flex items-center gap-2 px-3 py-2 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg hover:border-gray-400 dark:hover:border-gray-500 transition-colors duration-200 cursor-default"
                    >
                      <IconComponent className={`text-lg ${skill.color}`} />
                      <span className="text-sm font-medium text-gray-900 dark:text-white">
                        {skill.name}
                      </span>
                    </motion.div>
                  );
                })}
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.6 }}
          className="mt-12 pt-8 border-t border-gray-200 dark:border-gray-800"
        >
          <p className="text-gray-600 dark:text-gray-400 text-sm italic">
            Continuously learning and adapting to new technologies and industry best practices
          </p>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default SkillsTab;
